// * display settings keys
export const ASSESSMENTS_DETAILS = "assessments_details";
export const HIGHLIGHT_CELLS = "highlight_cells";
export const SORT_ASSESSMENTS_BY = "sort_assessments_by";
export const CATEGORY_VIEW = "category_view";
export const OTHERS_DISPLAY_SETTINGS = "others_display_settings";

// * display settings items keys
export const ASSIGNMENT_TYPE = "assignment_type";
export const GRADING_CATEGORY = "grading_category";
export const DUE_DATE = "due_date";
export const GRADING_PERIOD = "grading_period";
export const CREATION_DATE = "creation_date";
export const OPEN_DATE = "open_date";
export const ASSIGNMENT_DATE = "assignment_date";
export const EVALUATION_STATUS = "evaluation_status";
export const ASSESSMENT_NAME_A_Z = "assessment_name_A_Z";
export const ASSESSMENT_NAME_Z_A = "assessment_name_Z_A";
export const OPEN_DATE_EARLIEST_FIRST = "open_date_earliest_first";
export const OPEN_DATE_FARTHEST_FIRST = "open_date_farthest_first";
export const DUE_DATE_EARLIEST_FIRST = "due_date_earliest_first";
export const DUE_DATE_FARTHEST_FIRST = "due_date_farthest_first";
export const CREATION_DATE_OLDEST_TO_NEWEST = "creation_date_oldest_to_newest";
export const CREATION_DATE_NEWEST_TO_OLDEST = "creation_date_newest_to_oldest";
export const GROUP_BY_CATEGORIES = "group_by_categories";
export const SHOW_CATEGORY_WITH_THE_ASSIGNMENT_NAME =
  "show_category_with_the_assignment_name";
export const SHOW_EXCLUDED_TASKS_FROM_FINAL_CALCULATION =
  "show_excluded_tasks_from_final_calculation";
export const SHOW_TASKS_FROM_OTHER_CLASSES = "show_tasks_from_other_classes";
export const HIGHLIGHT_LATE_SUBMISSIONS = "highlight_late_submissions";
export const HIGHLIGHT_NOT_SUBMITTED = "highlight_not_submitted";
export const HIGHLIGHT_SUBMISSION_OVERDUE = "highlight_submission_overdue";
export const HIGHLIGHT_SUBMISSION_PENDING = "highlight_submission_pending";

// * components type
export const CHECKLIST = "CHECKLIST";
export const RADIO_BUTTON = "RADIO_BUTTON";

// * initial highlight cell settings
export const INITIAL_HIGHLIGHT_CELL_SETTINGS = {
  [HIGHLIGHT_LATE_SUBMISSIONS]: {
    enabled: true,
    displayColor: "var(--blue-600)",
    cellColor: "blue",
  },
  [HIGHLIGHT_NOT_SUBMITTED]: {
    enabled: true,
    displayColor: "var(--red-600)",
    cellColor: "red",
  },
  [HIGHLIGHT_SUBMISSION_OVERDUE]: {
    enabled: true,
    displayColor: "var(--yellow-600)",
    cellColor: "yellow",
  },
  [HIGHLIGHT_SUBMISSION_PENDING]: {
    enabled: true,
    displayColor: "var(--neutral-600)",
    cellColor: "#F5F5F5",
  },
};

// * initial display settings
export const INITIAL_DISPLAY_SETTINGS = {
  [ASSESSMENTS_DETAILS]: {
    [ASSIGNMENT_DATE]: true,
    [ASSIGNMENT_TYPE]: true,
    [GRADING_CATEGORY]: true,
    [DUE_DATE]: true,
    [GRADING_PERIOD]: true,
    [EVALUATION_STATUS]: true,
    [CREATION_DATE]: false,
    [OPEN_DATE]: false,
  },
  [SORT_ASSESSMENTS_BY]: {
    [ASSESSMENT_NAME_A_Z]: false,
    [ASSESSMENT_NAME_Z_A]: false,
    [OPEN_DATE_EARLIEST_FIRST]: false,
    [OPEN_DATE_FARTHEST_FIRST]: false,
    [DUE_DATE_EARLIEST_FIRST]: false,
    [DUE_DATE_FARTHEST_FIRST]: false,
    [CREATION_DATE_OLDEST_TO_NEWEST]: false,
    [CREATION_DATE_NEWEST_TO_OLDEST]: true,
  },
  [CATEGORY_VIEW]: {
    [GROUP_BY_CATEGORIES]: false,
    [SHOW_CATEGORY_WITH_THE_ASSIGNMENT_NAME]: true,
  },
  [OTHERS_DISPLAY_SETTINGS]: {
    [SHOW_EXCLUDED_TASKS_FROM_FINAL_CALCULATION]: true,
    [SHOW_TASKS_FROM_OTHER_CLASSES]: true,
  },
  [HIGHLIGHT_CELLS]: INITIAL_HIGHLIGHT_CELL_SETTINGS,
};
